<template>
    <div>
        <router-view @childrenRoute="hideNonChildren" />
        <div v-if="!isChildRoute">
            <div class="row m-3">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12 mb-2 d-flex">
                            <h4>POSTING BOS</h4>
                            <div class="ml-4" style="margin-top: 2px;">
                                <el-radio-group v-model="viewtype" size="mini">
                                <el-radio label="shift" border>Shift Settlement</el-radio>
                                <el-radio label="edc" border>EDC Detail</el-radio>
                                <el-radio label="transaction" border>Waa Transaction</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <el-card shadow="never">
                                <div class="text-center">
                                    <h5>SUMMARY BY UNIT (MONTHLY {{ year }})</h5>
                                </div>
                                <div>
                                    <BarChart :data="chartdata.summarybyunitmonthly" :width="500" :height="380"/>
                                    <Loader v-if="loading.table" />
                                </div>
                            </el-card>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <el-card shadow="never">
                                <div class="text-center">
                                    <h5>SUMMARY BY USER YTD ({{ year }})</h5>
                                </div>
                                <div>
                                    <BarChart :data="chartdata.summaryuserytd" :width="500" :height="380"/>
                                    <Loader v-if="loading.table" />
                                </div>
                            </el-card>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <el-card shadow="never">
                                <div class="text-center">
                                    <h5>SUMMARY BY USER (MONTHLY {{ year }})</h5>
                                </div>
                                <div>
                                    <BarChart :data="chartdata.summaryusermonthly" :width="500" :height="380"/>
                                    <Loader v-if="loading.table" />
                                </div>
                            </el-card>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <el-card shadow="never">
                                <div class="text-center">
                                    <h5>POSTING STATUS SUMMARY BY QUANTITY (MONTHLY {{ year }})</h5>
                                </div>
                                <div>
                                    <BarChart :data="chartdata.postingqty" :width="500" :height="380"/>
                                    <Loader v-if="loading.table" />
                                </div>
                            </el-card>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import BarCard from '@/views/pages/BarCard.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import Loader from '@/components/loader/Loader2.vue'
import PieChart from '@/components/chart/Pie.js'
import BarChart from '@/components/chart/BarChart.js'
import { AxiosWithJar, Config, Penanggalan, AppColors, FuelColor, Rainbow} from '@/utility.js'

export default
{
	extends:Fuel,
	components: { 
		//ReportResultTable,
		//Loader,
        BarChart,
        Loader,
	},
    data() {
		return {
            viewtype: 'shift',
            reportdata: {},
            isChildRoute: false,
			tabList:[
				{name:'Station'},
			],

            loading: {
                table: false,
                isSuccess: false,
            },

            chartdata: {
                postingqty: [],
                summaryuserytd: [],
                summaryusermonthly: [],
                summarybyunitmonthly: [],
            },
            stacked: false,
            year: Penanggalan().tahun,
        }
    },
	computed: {

	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        },
        viewtype() {
            console.log(this.viewtype);
            this.getData();
        }
    },
    mounted() {
        this.hideNonChildren();
        this.getData();
    },
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/maintenance/posting-bos';
        },
        getData() {
            this.urlRequestParams=Config().apiURL

            if(this.viewtype == 'shift')
                this.urlRequestParams+='/v1/maintenance/overviewshift?'
            else if(this.viewtype == 'edc')
                this.urlRequestParams+='/v1/maintenance/overviewedc?'
            else if(this.viewtype == 'transaction')
                this.urlRequestParams+='/v1/maintenance/overviewtransaction?'

            //this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            //this.urlRequestParams+='&stationid='+this.stationid

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;  // Update the data property of reportdata
                    this.year = this.reportdata.data.year;
					this.setBarchartSummaryByUserYtd();
					this.setBarchartSummaryByUserMonthly();
					this.setBarchartPostingQty();
					this.setBarchartGroupByUnitCount();
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        setBarchartSummaryByUserYtd() {
            let label = 'Username';
            let legend = 'Legend';
            let amount = 'Cnt';
			this.chartdata.summaryuserytd = this.processBarChart(this.reportdata.data.summary_by_user_ytd, legend, "", amount, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);    
        },
        setBarchartSummaryByUserMonthly() {
            let label = 'MonthName';
            let legend = 'Username';
            let amount = 'Cnt';
			this.chartdata.summaryusermonthly = this.processBarChart(this.reportdata.data.summary_by_user_monthly, legend, "", amount, false, label, "", 1, 2, AppColors, false, false, false, true);    
        },
        setBarchartPostingQty() {
            let label = 'MonthName';
            let legend = 'Label';
            let amount = 'Cnt';
			this.chartdata.postingqty = this.processBarChart(this.reportdata.data.posting_qty, legend, "", amount, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);    
        }, 
        setBarchartGroupByUnitCount() {
            let label = 'MonthName';
            let legend = 'Legend';
            let amount = 'Cnt';
			this.chartdata.summarybyunitmonthly = this.processBarChart(this.reportdata.data.group_by_month_unit, legend, "", amount, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);    
        }, 
    },
}
</script>
